"use strict";

/**
 * @function
 * @description Function to include the lazysizez plugin
 */
const includeLazyPlugin = () => {
    require("../thirdParty/lazysizes.min.js");
};

/**
 * @function
 * @description Function to manage the images if browser supports native lazy loading
 */
const initNativeLazyLoading = elem => {
    let allImages;

    if (elem !== undefined) {
        allImages = document.querySelectorAll(elem);
    } else {
        allImages = document.querySelectorAll("img[loading='lazy']");
    }

    allImages.forEach(img => {
        if (img.srcset) {
            img.dataset.srcset = img.srcset;
        } else if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
        }

        if (img.dataset.src) {
            img.src = img.dataset.src;
        }

        if (img.classList.contains("lazyload")) {
            img.classList.remove("lazyload");
        }
    });
};

/**
 * @function
 * @description Function to manage the images if browser doesn't support native lazy loading
 */
const initLazyLoading = elem => {
    let allImages;

    if (elem !== undefined) {
        allImages = document.querySelectorAll(elem);
    } else {
        allImages = document.querySelectorAll("img[loading='lazy']");
    }

    allImages.forEach(img => {
        img.removeAttribute("loading");
    });
};

/**
 * @function
 * @description Function to refresh the image lazy loading (without calling the Lazy plugin again) after an ajax call (native or by script)
 */
const refreshLazyLoadingFeature = elem => {
    if (elem !== undefined) {
        if ("loading" in HTMLImageElement.prototype && !isAppleDevice()) {
            initNativeLazyLoading(elem);
        } else {
            initLazyLoading(elem);
        }
    } else {
        if ("loading" in HTMLImageElement.prototype && !isAppleDevice()) {
            initNativeLazyLoading();
        } else {
            initLazyLoading();
        }
    }
};

/**
 * @function
 * @description Function to see if the device is Apple device (returns true or false)
 */
const isAppleDevice = () => {
    if (navigator && navigator.platform) {
        return [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod"
        ].includes(navigator.platform) || navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    } else {
        return false;
    }
};

/**
 * @function
 * @description Function to manage the image lazy loading (native or by script)
 */
const manageLazyLoadingFeature = () => {
    if ("loading" in HTMLImageElement.prototype && !isAppleDevice()) {
        initNativeLazyLoading();
    } else {
        initLazyLoading();
        includeLazyPlugin();
    }
};

module.exports = {
    initNativeLazyLoading: initNativeLazyLoading,
    initLazyLoading: initLazyLoading,
    manageLazyLoadingFeature: manageLazyLoadingFeature,
    refreshLazyLoadingFeature: refreshLazyLoadingFeature
};
